var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-feature-item",on:{"click":_vm.triggerEvent}},[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }